import "./style.css";
import Cabeleireira from "../../images/intro/gerusa.jpg";

export default function Intro() {
  return (
    <div className="intro-container">
      <div className="intro-photo">
        <img src={Cabeleireira} alt="Cabeleireira"/>
      </div>
      <div className="intro-children">
        <h2 className="intro-text">Cuidamos de cada detalhe,<br/>valorizamos sua essência.</h2>
        <div className="intro-cta">
          <a href="https://wa.me/554284093699" target="_blank" rel="noreferrer">
            <button>Agende agora!</button>
          </a>
        </div>
      </div>
    </div>
  );
};